<template>
  <div :class="classes" class="asd20-accordion">
    <div class="asd20-accordion__header" @click="toggleOpen">
      <component
        :is="tag"
        :id="`accordion-${_uid}-heading`"
        class="asd20-accordion__heading"
      >
        <span
          v-if="color"
          class="asd20-accordion__color"
          :style="{ '--accordion-color': color }"
        ></span>
        {{ heading || label }}
        <span v-if="description" class="asd20-accordion__description">
          {{ description }}
        </span>
      </component>
      <slot name="header" />
      <asd20-badge slot="header" :visible="badge > -1" :value="badge" static />
      <asd20-button
        :aria-labelledby="`accordion-${_uid}-heading`"
        :aria-controls="`accordion-${_uid}-content`"
        :icon-angle="open ? 180 : 90"
        icon="chevron"
        size="sm"
        transparent
        @click.native.stop="toggleOpen"
      />
    </div>

    <div
      v-show="open"
      :id="`accordion-${_uid}-content`"
      :aria-expanded="open"
      class="asd20-accordion__content"
    >
      <asd20-viewport :scrollable="scrollable" :max-height="maxHeight">
        <slot />
      </asd20-viewport>
    </div>
  </div>
</template>

<script>
import Asd20Badge from '../../atoms/Asd20Badge'
import Asd20Button from '../../atoms/Asd20Button'
import Asd20Viewport from '../../atoms/Asd20Viewport'
export default {
  name: 'Asd20Accordion',
  components: { Asd20Badge, Asd20Button, Asd20Viewport },
  props: {
    tag: { type: String, default: 'h3' },
    label: { type: String, default: '' },
    heading: { type: String, default: '' },
    description: { type: String, default: '' },
    badge: { type: Number, default: -1 },
    opened: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    shaded: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    maxHeight: { type: String, default: 'none' },
    color: { type: String, default: '' },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    classes() {
      return {
        'asd20-accordion--expanded': this.expanded,
        'asd20-accordion--shaded': this.shaded,
      }
    },
  },
  created() {
    this.open = this.opened
  },
  methods: {
    toggleOpen: function() {
      this.open = !this.open
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-accordion {
  border-top: 1px solid var(--color__tertiary);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  &__content {
    border-top: 1px solid var(--color__tertiary);
    padding: space(1);
  }
  &__heading {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 1rem;
    font-weight: bold;
    color: var(--website-page__title-color);
    line-height: 1.1;
    margin: 0;
    padding-left: space(1);
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  &__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;

    .asd20-button,
    .asd20-badge {
      margin-left: auto;
    }
    .asd20-badge + .asd20-button {
      margin-left: 0;
    }
  }

  &__color {
    --accordion-color: currentColor;
    display: block;
    width: space(0.5);
    height: space(0.5);
    background: var(--accordion-color);
    border-radius: 50%;
    margin-right: space(0.25);
  }

  &__description {
    display: block;
    flex-basis: 100%;
    font-weight: normal;
    font-size: 0.75rem;
    color: var(--website-card__reverse-background-color);
    color: var(--website-page__foreground-color);

    margin-top: space(0.125);
  }

  &--expanded {
    .asd20-accordion__content {
      padding: 0;
    }
  }
  &--shaded {
    .asd20-accordion__content {
      background: var(--website-page__alternate-background-t50);
    }
  }
}
</style>
